// ============================================================
// 生成 Schema（阶段一 T1）：公共片段
// ============================================================
import { z } from 'zod';
import { DATA_FIELD_MAPPING_TYPES, SIMPLE_FILTER_PATTERN } from './constants';

/** 三维向量（position/rotation/scale） */
export const vec3Schema = z.array(z.number().finite()).length(3);
export type Vec3 = z.infer<typeof vec3Schema>;

/** 四份 Bundle 共用的 meta */
export const bundleMetaSchema = z
  .object({
    name: z.string().min(1).max(120),
    description: z.string().max(500).optional(),
    baseId: z.string().max(64).optional(),
  })
  .strict();
export type BundleMeta = z.infer<typeof bundleMetaSchema>;

/** 字段映射（packages/shared/src/types/index.ts DataFieldMapping 对齐） */
export const dataFieldMappingSchema = z
  .object({
    sourceField: z.string().min(1).max(120),
    targetField: z.string().max(120).optional(),
    type: z.enum(DATA_FIELD_MAPPING_TYPES).optional(),
    format: z.string().max(120).optional(),
  })
  .strict();

/**
 * 数据解析管线（DataParserConfig 的安全子集）：
 * - 允许：path / mapping / filter（仅简单比较）
 * - 禁止：transform（JS 转换函数体），strict 模式会直接拒绝该字段
 */
export const safeParserSchema = z
  .object({
    path: z.string().max(300).optional(),
    mapping: z.array(dataFieldMappingSchema).max(50).optional(),
    filter: z
      .string()
      .max(200)
      .regex(SIMPLE_FILTER_PATTERN, 'filter 仅允许形如 value > 10 / item.value <= 3.5 的简单比较')
      .optional(),
  })
  .strict();
export type SafeParser = z.infer<typeof safeParserSchema>;
